<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'80px'" :get-action="queryApi" :serial="serial" :selection="selection" :row-height="60" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsBrand.table.name')" prop="brandName">
            <BjInput v-model="queryParams.brandName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsBrand.table.code')" prop="code">
            <BjInput v-model="queryParams.code" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsBrand.page.Status')" prop="status">
            <BjSelectLov v-model="queryParams.status" :option-list="STATUS_ENABLED_NUM" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button v-permission:BusinessGoodsBrandIndex_Delete type="primary" :disabled="tableOperationProp.notSelected" class="delete-btn" @click="onDeleteSelected">{{ $t('delText') }}</el-button>
          <el-button v-permission:BusinessGoodsBrandIndex_Add type="primary" class="main-btn" @click="onAdd">{{ $t('goodsBrand.page.AddBrand') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <div v-else-if="col.prop === 'logo'" class="flex flex-center">
                <BjKeyImage :url="scope.row[col.prop]" height="50px" preview />
              </div>

              <el-tag v-else-if="col.prop === 'status'" :type="scope.row.status ? 'success' : 'info'">{{ $t(STATUS_ENABLED_NUM.bjGet(scope.row.status)) }}</el-tag>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="scope">
              <el-button v-permission:BusinessGoodsBrandIndex_Edit type="text" class="edit-btn" @click="onEdit(scope.row)">{{ $t('editText') }}</el-button>
              <el-button v-if="!scope.row.status" v-permission:BusinessGoodsBrandIndex_Status type="text" @click="onStatus(1, scope.row)">{{ $t('enableText') }}</el-button>
              <el-button v-if="scope.row.status" v-permission:BusinessGoodsBrandIndex_Status type="text" @click="onStatus(0, scope.row)">{{ $t('disableText') }}</el-button>
              <el-button v-permission:BusinessGoodsBrandIndex_Delete :disabled="scope.row.status == 1" type="text" class="delete-btn" @click="onDelete(scope.row)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { goodsApi } from '@/api';
import DataForm from './components/DataForm.vue';
import { STATUS_ENABLED_NUM } from '@/utils/constants';
export default {
  name: 'BusinessGoodsBrand',
  components: {
    DataForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_ENABLED_NUM,
      queryApi: goodsApi.getPageBrand,
      // 查询参数
      queryParams: {
        brandName: null,
        code: null,
        status: null,
      },
      labelsVersion: 11,
      labelList: [
        { label: 'goodsBrand.table.code', prop: 'code', isCheck: true, disabled: false, width: 200 },
        { label: 'goodsBrand.table.name', prop: 'brandName', isCheck: true, disabled: false, width: 200 },
        { label: 'goodsBrand.table.LOGO', prop: 'logo', isCheck: true, disabled: false, width: 200 },
        { label: 'goodsBrand.table.Manufacturer', prop: 'manufacturer', isCheck: true, disabled: false, width: 200 },
        { label: 'table.remarkText', prop: 'remark', isCheck: true, disabled: false, width: 200 },
        { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false },
        { label: 'goodsBrand.table.Operator', prop: 'createdName', isCheck: true, disabled: false },
        { label: 'table.createTimeText', prop: 'createDate', isCheck: true, disabled: false, width: 135 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    /** 禁用 */
    onStatus(flag, row) {
      const TEXT = this.$t(STATUS_ENABLED_NUM.bjGet(flag));
      this.$confirm(
        `${this.$t('toast.youAreTipText')} ${TEXT} ${row.brandName}，${this.$t(
          'toast.continueTipText',
        )}`,
        this.$t('toast.hintText'),
        {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        },
      )
        .then(() => {
          this.operationApi({
            ids: [row.id],
            status: flag,
          });
        });
    },
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(
        `${this.$t('toast.youAreDelTipText')} ${row.brandName}，${this.$t(
          'toast.continueTipText',
        )}`,
        this.$t('toast.hintText'),
        {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        },
      )
        .then(() => {
          this.batchDeleteApi({ ids: [row.id] });
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }
      if (this.selectedRows.some(e => e.status)) {
        this.$message.warning(this.$t('toast.delEnabledTipText'));
        return;
      }
      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: ids });
        })
        .catch(() => {});
    },
    /** 新建 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 编辑操作 */
    onEdit(row) {
      this.$refs.DataForm.show(this.$lodash.clone(row));
    },

    operationApi(API_DATA) {
      goodsApi.operationBrand(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.reFresh();
        }
      });
    },
    batchDeleteApi(API_DATA) {
      goodsApi.batchDeleteBrand(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
